import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { ViewBoundary } from './components/ViewBoundary';
import { AuthProvider } from './auth/AuthContext';
import './styles/index.css';

const container = document.getElementById('root');
if (!container) throw new Error('missing #root');

createRoot(container).render(
  <StrictMode>
    <ViewBoundary>
      <AuthProvider>
        <Suspense
          fallback={
            <main className="route-loading" role="status">
              Opening Throughline…
            </main>
          }
        >
          <App />
        </Suspense>
      </AuthProvider>
    </ViewBoundary>
  </StrictMode>,
);
